import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { HeaderBannerProps } from '..';

const useStyles = makeStyles({ name: 'TabletHeaderBanner' })(({ Skoda: { settings: { headerBanner } } }) => ({
	imageContainer: {
		position: 'relative',
		overflow: 'hidden'
	},
	image: {
		width: '100%',
		height: 'auto'
	},
	content: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 20,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end'
	},
	gradient: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 43.75%, ${headerBanner.color} 99%)`
	},
	root: {

	}
}));

export const TabletHeaderBanner: React.FC<HeaderBannerProps> = (props) => {
	const { children, img, onImageLoad } = props;
	const { classes: styles } = useStyles(undefined, {props});

	const handleImageOnLoad = () => {
		if (onImageLoad) onImageLoad();
	};

	const images: string[] = typeof (img) === 'string' ? [img] : img;
	const [defaultImg, ...other] = images;

	return (
		<div data-test='header-banner-tablet' className={styles.root}>
			<div className={styles.imageContainer}>
				<picture>
					{other.map(anotherFormatImage =>
						<source srcSet={anotherFormatImage} type={`image/${anotherFormatImage.split('.').pop()}`} />)}
					<img width={1152} height={780} className={styles.image} src={defaultImg} alt='banner' onLoad={handleImageOnLoad} />
				</picture>
				<div className={styles.gradient} />
				<div className={styles.content}>
					{children}
				</div>
			</div>
		</div>
	);
};
